/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumDestinatarioDTOTipoDestinatario =
  (typeof EnumDestinatarioDTOTipoDestinatario)[keyof typeof EnumDestinatarioDTOTipoDestinatario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumDestinatarioDTOTipoDestinatario = {
  RICHIEDENTE: 'RICHIEDENTE',
  TITOLARE: 'TITOLARE',
  RESPONSABILE_PROCEDIMENTO: 'RESPONSABILE_PROCEDIMENTO',
  ENDOPROCEDIMENTI_PRIMO_LIVELLO: 'ENDOPROCEDIMENTI_PRIMO_LIVELLO',
  PROCURATORE: 'PROCURATORE',
  DELEGATI_FIRMA: 'DELEGATI_FIRMA',
  DELEGATI_COMPILAZIONE: 'DELEGATI_COMPILAZIONE',
  ALTRO_UFFICIO_VARIABILE: 'ALTRO_UFFICIO_VARIABILE',
  IMPRESA_TITOLARE: 'IMPRESA_TITOLARE',
  SOGGETTO_GIURIDICO: 'SOGGETTO_GIURIDICO',
  UFFICIO_RICHIEDENTE: 'UFFICIO_RICHIEDENTE',
  UFFICIO_COMPETENZA_SECONDARIA: 'UFFICIO_COMPETENZA_SECONDARIA',
} as const;
